import React from "react";
import "../../../styles/pt/pt-trials.css";
import { BodyBuilder } from "../../../exports/Images";

const MemberDetails = ({ userData }) => {
  return (
    <div className="member-detail-container user-profile-container">
      <div className="member-detail user-profile-img">
        <img
          src={userData?.userProfile || BodyBuilder}
          alt={userData?.userName || ""}
          className="user-image"
        />
      </div>

      <div className="member-detail user-profile-details">
        <div className="user-details">
          <div className="user-details-head">
            <p className="head-name">member Name</p>
          </div>
          <div className="user-details-info">
            <p className="info-name">{userData?.userName || "NA"}</p>
          </div>
        </div>

        <div className="user-details">
          <div className="user-details-head">
            <p className="head-name">member Mobile</p>
          </div>
          <div className="user-details-info">
            <p className="info-name">{userData?.userMobile || "NA"}</p>
          </div>
        </div>

        <div className="user-details">
          <div className="user-details-head">
            <p className="head-name">member email</p>
          </div>
          <div className="user-details-info">
            <p className="info-name" style={{ textTransform: "lowercase" }}>
              {userData?.userEMail || "NA"}
            </p>
          </div>
        </div>

        <div className="user-details">
          <div className="user-details-head">
            <p className="head-name">gym name</p>
          </div>
          <div className="user-details-info">
            <p className="info-name">{userData?.gymName || "NA"}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MemberDetails;
